import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { TransactionCreate } from '../interfaces/accounting.interface';

export const TransactionService = {
    getTransactionsByInstitution: async (page: number = 0, size: number = 10, type?: string, startDate?: string, endDate?: string) => {
        const institutionId = AuthService.getSelectedInstitution();
        let url = `${ENDPOINTS.TRANSACTION.LIST_BY_INSTITUTION(institutionId!)}?page=${page}&size=${size}`;
        if (type) url += `&type=${type}`;
        if (startDate) url += `&startDate=${startDate}`;
        if (endDate) url += `&endDate=${endDate}`;
        const response = await axios.get(url);
        return response.data;
    },
    getTransactionById: async (id: string) => {
        const response = await axios.get(ENDPOINTS.TRANSACTION.BY_ID(id));
        return response.data;
    },
    createTransaction: async (transaction: TransactionCreate) => {
        const response = await axios.post(ENDPOINTS.TRANSACTION.BASE, transaction);
        return response.data;
    },
    deleteTransaction: async (id: string) => {
        await axios.delete(ENDPOINTS.TRANSACTION.DELETE(id));
    },
};
